var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":"0"}},[_c('el-input',{staticClass:"width-full",attrs:{"size":"mini"},model:{value:(_vm.data.content),callback:function ($$v) {_vm.$set(_vm.data, "content", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"data.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }